import { isNullOrUndefined } from '~/util/validators/baseComponentsValidators'
import { trimSlashes } from '~/util/helpers/string'

export default ({ app }, inject) => {
  const { router } = app

  inject('modal', {

    /** @param {Object} OpenConfig
      * @param {string} OpenConfig.page  */
    open({ page, query }) {
      if (isNullOrUndefined(page)) return

      const queries = {
        ...router.currentRoute.query,
        page: trimSlashes(page),
        ...query,
      }
      return router.push({ query: queries })
    },

    close() {
      const queries = {
        ...router.currentRoute.query,
      }
      delete queries.page
      return router.push({ query: queries })
    },

    /** @returns {string | null} */
    current() {
      return router.currentRoute.query.page || null
    },
  })
}
